import DoubleInfoSlide from "./DoubleInfoSlide";
import InfoSlide from "./InfoSlide";
import VideoBottomSlide from "./VideoBottomSlide";
import VideoTopSlide from "./VideoTopSlide";
import { type TestimonialV3, VideoTrackingConfig } from "./data";

type GetSlideComponentOptions = {
    trackingConfig?: VideoTrackingConfig;
    slideClassName?: string;
};

export const getSlideComponent = (testimonial: TestimonialV3, options?: GetSlideComponentOptions) => {
    const { trackingConfig, slideClassName } = options ?? {};

    switch (testimonial.type) {
        case "video-top":
            return <VideoTopSlide testimonial={testimonial} trackingConfig={trackingConfig} className={slideClassName} />;
        case "video-bottom":
            return <VideoBottomSlide testimonial={testimonial} trackingConfig={trackingConfig} className={slideClassName} />;
        case "info":
            return <InfoSlide testimonial={testimonial} className={slideClassName} />;
        case "double-info":
            return <DoubleInfoSlide testimonial={testimonial} className={slideClassName} />;
        default:
            return <InfoSlide testimonial={testimonial} className={slideClassName} />;
    }
};

type SlideWidthClassNames = {
    wide?: string;
    default?: string;
};

export const getSlideWidth = (testimonial: TestimonialV3, overrides?: SlideWidthClassNames) => {
    if (testimonial.type === "info" || testimonial.type === "double-info") {
        return overrides?.wide ?? "basis-[88.3%] md:basis-[549px]";
    }
    return overrides?.default ?? "basis-[88.3%] md:basis-[368px]";
};
